import React from "react";
export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-14 prose">
      <h1 className="font-heading text-4xl font-bold text-gray-900">Privacy Policy</h1>
      <p className="mt-4 text-gray-700 leading-relaxed">Access Local respects your privacy. We collect only the information required to operate the service — account details (name, email), venue nominations, inspection records and analytics. We never sell your personal data.</p>
      <h2 className="mt-8 font-heading text-2xl font-semibold text-gray-900">What we collect</h2>
      <ul className="mt-3 space-y-2 text-gray-700 list-disc pl-6">
        <li>Account information (name, email, hashed password)</li>
        <li>Nominations and inspection submissions you create</li>
        <li>Contact form messages</li>
      </ul>
      <h2 className="mt-8 font-heading text-2xl font-semibold text-gray-900">Your rights</h2>
      <p className="mt-2 text-gray-700 leading-relaxed">You can request access, correction or deletion of your data at any time by contacting us.</p>
    </div>
  );
}
